<template>

  <!-- Right sidebar -->
  <ul class="nav navbar-right be-user-nav">
    <li class="dropdown">
      <a href="#" class="notifications" data-toggle="dropdown" role="button" aria-expanded="false" v-if="allNotifications.length > 0">
        <i class="fas fa-bell"></i>
        <span class="notification-count">{{allNotifications.length}}</span>
      </a>
      <a href="#" class="notifications"  data-toggle="dropdown" role="button" aria-expanded="false" v-else>
        <i class="far fa-bell"></i>
      </a>
      <ul role="menu" class="dropdown-menu" style="width:300px;">
        <li>
          <NotificationList :show-delete="false" />
        </li>
      </ul>
    </li>
    <li class="dropdown">
      <a href="#" data-toggle="dropdown" role="button" aria-expanded="false" class="dropdown-toggle">
        <img src="/static/img/avatar.png" alt="Avatar">
      </a>

      <ul role="menu" class="dropdown-menu">
        <li>
          <div class="user-info">
            <div class="user-name">{{currentUser.email}}</div>
            <div class="user-position online">Available</div>
          </div>
        </li>
        <li><router-link :to="{name: 'subject-shelf'}"><span class="icon mdi mdi-home"></span> Subject Shelf</router-link></li>
        <li><router-link :to="{name: 'user-account'}"><span class="icon mdi mdi-face"></span> Account</router-link></li>
        <li><router-link :to="{name: 'user-settings'}"><span class="icon mdi mdi-settings"></span> Settings</router-link></li>
        <li><a v-on:click.prevent="logout" href><span class="icon mdi mdi-power"></span> Logout</a></li>
      </ul>
    </li>
  </ul>

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import NotificationList from '../notifications/NotificationList'

  export default {
    components: {
      NotificationList,
    },

  data() {
    return {}
  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
    ...mapGetters({
      allNotifications: 'allNotifications',
    }),
  },

  methods: {
    ...mapActions([
      'logout'
    ]),
    removeNotification(n) {
      console.log(n)
      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
    },
    removeAllNotifications() {
      this.$store.commit('REMOVE_ALL_NOTIFICATIONS', {});
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .be-user-nav {margin:18px 60px 0px 0px;}
  .dropdown { float: left; }
  .dropdown-toggle { padding: 15px 14px 14px 14px !important;}
  .be-user-nav > li.dropdown .dropdown-menu { right: 0px !important; padding: 0px; }

  .notifications { padding: 15px 22px 14px 22px !important; color: #4285f4; font-size: 20px !important; line-height: 32px; position: relative; }
  .notifications span { position: absolute; top: 10px; right: 10px; font-size: 12px; border: 1px solid #4285f4 ;background:#FFFFFF;border-radius:10px;display:block;line-height:20px;height:20px;min-width:20px;text-align:center;}

  .notification { position: relative; }
  .notification a { padding: 10px 20px; display: block; }
  .notification:nth-child(even) a {background:#F6F6F6;}
  .notification span {display:none;position:absolute;top:10px;right:10px;cursor:pointer;}
  .notification a:hover { background: #4285f4;color:#FFFFFF; }
  .notification:hover span { display: block; }
  .clear-all { padding: 20px 20px; cursor: pointer; background: #FFFFFF !important; text-align: center; border-top: 1px solid #DDDDDD; }
  .clear-all:hover { background: #4285f4 !important; color: #FFFFFF; }

  .be-user-nav > li.dropdown > a:after { display: none !important; }

  @media (max-width: 1100px) {
    .be-user-nav { margin: 18px 20px 0px 0px; }
  }
  @media (max-width: 850px) {
    .be-user-nav { margin: 18px 10px 0px 0px; }
    .notifications { padding: 15px 15px 14px 15px !important }
  }
</style>



// WEBPACK FOOTER //
// LoggedInLinks.vue?8bb41a08